



















import { Prop, Component, Vue } from "vue-property-decorator";

import User from "@/schedule/entities/user";
import ScheduleCellViewModel from "../presenters/schedule-cell";
import VChart from "../../../components/chart/VChart.vue";
import VChartRow from "../../../components/chart/VChartRow.vue";
import ScheduleRow from "./ScheduleRow.vue";
import ScheduleCell from "./ScheduleCell.vue";
import ScheduleUser from "./ScheduleUser.vue";
import VGridMask from "../../../components/VGridMask.vue";

@Component({
  components: {
    VChart,
    VChartRow,
    VGridMask,
    ScheduleUser,
    ScheduleRow,
    ScheduleCell
  }
})
export default class ScheduleCalendar extends Vue {
  @Prop({ required: true }) user!: User;
  @Prop({ required: true }) cells!: ScheduleCellViewModel[];

  clickCell(cell: ScheduleCellViewModel) {
    this.$emit("clickCell", cell.userId, cell.date);
  }
}
